import React from 'react';

const LayoutMain = ({ children, className }) => {
  return <div className={`max-w-main w-full mx-auto bg-white py-6 px-8 ${className || ''}`}>{children}</div>;
};

export default React.memo(LayoutMain);
